import { useNavigate } from 'react-router';

interface DashboardCardLinkButtonProps {
  text: string;
  href: string;
}

/** Plain HTML — DevExtreme Button after dashboard load can hit React #185 under React 19. */
export function DashboardCardLinkButton({ text, href }: DashboardCardLinkButtonProps) {
  const navigate = useNavigate();

  return (
    <button type="button" className="dashboard-card-link-btn" onClick={() => navigate(href)}>
      {text}
    </button>
  );
}
